import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import {
  Favorite,
  FavoriteBorder,
  ChatBubbleOutline
} from '@material-ui/icons';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteLikeRequest, likeRequest } from './api';
import { deleteKudosById } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';
import { routes } from '../../../assets/routes';
import { IconButton } from '@material-ui/core';
import { useTranslation } from '../../../i18n/LanguageProvider';

const useStyles = makeStyles({
  input: {
    height: '35px',
    width: '35px',
    boxSizing: 'border-box'
  }
});

const Like = (props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const classes = useStyles();
  const [likeByMe, setLikeByMe] = useState(props.likedByMe);
  const [likesCount, setLikesCount] = useState(props.likesCount);
  const [commentsCount, setCommentsCount] = useState(props.commentsCount);

  const deleteLikeRequestMutation = useMutation(deleteLikeRequest, {
    onSuccess(response) {
      setLikesCount(response.data);
      queryClient.invalidateQueries(['kudos']);
      queryClient.fetchQuery(['likeList', props.id]);
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const deleteKudosByIdMutation = useMutation(deleteKudosById, {
    onSuccess() {
      queryClient.invalidateQueries(['kudos']);
      toast.success(t('kudos.deleted'));
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const likeRequestMutation = useMutation(likeRequest, {
    onSuccess(response) {
      setLikesCount(response.data);
      queryClient.invalidateQueries(['kudos']);
      queryClient.fetchQuery(['likeList', props.id]);
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const likeAndDislike = (e) => {
    e.stopPropagation();
    setLikeByMe(!likeByMe);
    if (likeByMe) {
      deleteLikeRequestMutation.mutate({ id: props.id });
    } else {
      likeRequestMutation.mutate({ id: props.id });
    }
  };

  useEffect(() => {
    setLikeByMe(props.likedByMe);
    setLikesCount(props.likesCount);
    setCommentsCount(props.commentsCount);
  }, [props.likedByMe, props.likesCount, props.commentsCount]);

  return (
    <div className={styles.actions} style={{ overflow: 'auto' }}>
      <div className={styles.number}>
        <Checkbox
          checked={likeByMe}
          classes={{ root: classes.input }}
          icon={<FavoriteBorder />}
          disabled={props.isFetching}
          checkedIcon={<Favorite color="error" />}
          onClick={(e) => {
            likeAndDislike(e);
          }}
        />
        {Boolean(likesCount) && likesCount}
      </div>
      <div className={styles.number}>
        <IconButton
          size="small"
          onClick={() => {
            history.push(generatePath(routes.KUDOS, { id: props.id }));
          }}
          style={{
            padding: '6px'
          }}
        >
          <ChatBubbleOutline fontSize="small" />
        </IconButton>
        {commentsCount > 0 && commentsCount}
      </div>
      {props.isRemoveKudosActive && (props.isSysAdmin || props.isOrgAdmin) && (
        <div style={{ float: 'left' }}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              deleteKudosByIdMutation.mutate({ id: props.id });
            }}
            style={{
              padding: '6px'
            }}
          >
            <DeleteOutlinedIcon />
          </IconButton>
        </div>
      )}
      <div style={{ clear: 'both' }}></div>
    </div>
  );
};
Like.propTypes = {
  id: PropTypes.number,
  likesCount: PropTypes.number,
  likedByMe: PropTypes.bool,
  isFetching: PropTypes.bool,
  commentsCount: PropTypes.number,
  isSysAdmin: PropTypes.bool,
  isOrgAdmin: PropTypes.bool,
  isRemoveKudosActive: PropTypes.bool
};

export default Like;
